export default class StringUtils {
  /**
   * It ensures that a string ends with a specific postfix, adding it if required
   * @param original
   * @param postfix
   */
  public static ensurePostfix(original: string, postfix: string): string {
    if (original.endsWith(postfix)) {
      return original;
    }

    return original + postfix;
  }

  public static snakeCaseToSentence(str: string): string {
    const string = str.replace(/_/g, ' ');
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  public static capitalizeWords(string: string): string {
    return string
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  public static isValidEmail(email: string): boolean {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email
    );
  }

  /**
   * Formats a string by converting it to title case. For example, "HELLO_WORLD" becomes "Hello World".
   * @param input - The input string.
   * @returns The formatted string.
   */
  public static toTitleCase(input: string): string {
    return input
      .toLowerCase()
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
